module.exports = __webpack_public_path__ + "img/Ilustracao-login.d064626d.png";